var _ellipse, _ellipse2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHireNurse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 27.9865,
    cy: 28,
    rx: 27.9865,
    ry: 28,
    fill: "#F52A4C"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.6498,
    cy: 36,
    rx: 6.66344,
    ry: 6.66667,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5103 27.5933H29.3989C29.7512 27.5933 30.0369 27.3075 30.0369 26.955C30.0369 26.6025 29.7512 26.3167 29.3989 26.3167H19.5103C19.1578 26.3167 18.8723 26.6025 18.8723 26.955C18.8723 27.3075 19.1578 27.5933 19.5103 27.5933Z",
    fill: "#F52A4C",
    stroke: "#F52A4C",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4305 30.4656H19.5103C19.1578 30.4656 18.8723 30.7514 18.8723 31.1039C18.8723 31.4563 19.1578 31.7421 19.5103 31.7421H25.4305C25.7828 31.7421 26.0685 31.4563 26.0685 31.1039C26.0685 30.7514 25.7828 30.4656 25.4305 30.4656Z",
    fill: "#F52A4C",
    stroke: "#F52A4C",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5055 29.0484V18.019C36.5051 16.2566 35.0771 14.8282 33.3157 14.8276H30.7V13.6085C30.7 13.2558 30.4145 12.9702 30.062 12.9702C29.7097 12.9702 29.424 13.2558 29.424 13.6085V14.8276H20.7475V13.6085C20.7475 13.2558 20.462 12.9702 20.1096 12.9702C19.7573 12.9702 19.4716 13.2558 19.4716 13.6085V14.8276H16.8559C15.0945 14.8282 13.6668 16.2566 13.666 18.019V35.3102C13.6668 37.0724 15.0945 38.5008 16.8559 38.5016H28.665C29.8925 41.6472 33.1845 43.473 36.5014 42.8483C39.8182 42.2238 42.2214 39.3254 42.222 35.9485C42.2282 32.5209 39.7592 29.6614 36.5055 29.0484ZM16.8625 16.1042H19.4782V17.3233C19.4782 17.6758 19.7637 17.9616 20.1161 17.9616C20.4684 17.9616 20.7541 17.6758 20.7541 17.3233V16.1042H29.4306V17.3233C29.4306 17.6758 29.7161 17.9616 30.0686 17.9616C30.4208 17.9616 30.7065 17.6758 30.7065 17.3233V16.1042H33.3222C34.3779 16.1072 35.233 16.9627 35.2362 18.019V19.5637H14.9485V18.019C14.9493 16.9617 15.8058 16.105 16.8625 16.1042ZM16.8625 37.225C15.8066 37.222 14.9515 36.3663 14.9485 35.3102V20.8339H35.2296V28.9273H35.2104C33.1269 28.9305 31.1521 29.8582 29.8192 31.4607C28.486 33.063 27.9325 35.1745 28.3076 37.225H16.8625ZM35.2104 41.693C32.0395 41.693 29.4687 39.1211 29.4687 35.9485C29.4687 32.7758 32.0395 30.2039 35.2104 30.2039C38.3816 30.2039 40.9522 32.7758 40.9522 35.9485C40.9474 39.1191 38.3796 41.6882 35.2104 41.693Z",
    fill: "#F52A4C",
    stroke: "#F52A4C",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1647 33.657L34.3754 37.2761L32.4166 35.3102C32.1684 35.0616 31.7657 35.0616 31.5173 35.3102C31.2687 35.5587 31.2687 35.9616 31.5173 36.2101L33.9222 38.6165C34.0418 38.7369 34.2053 38.8038 34.3754 38.8016C34.5401 38.803 34.6984 38.7387 34.8154 38.6226L39.0515 34.5695C39.1735 34.4529 39.2441 34.2927 39.2479 34.1237C39.2513 33.9548 39.1877 33.7914 39.0707 33.6698C38.8223 33.4204 38.4201 33.4147 38.1647 33.657Z",
    fill: "#F52A4C",
    stroke: "#F52A4C",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHireNurse);
export default __webpack_public_path__ + "static/media/hireNurse.26558d68e61b233bb882bdf2642d5905.svg";
export { ForwardRef as ReactComponent };